import { apiClient } from '../../gateways/api'
import type { Projectdossier } from '../types/Projectdossier'

export { unlinkProjectFromProjectdossier }

const unlinkProjectFromProjectdossier = async ({
  id,
  projectId,
}: {
  id: string
  projectId: string
}): Promise<Projectdossier> => {
  const { data } = await apiClient({
    url: `/rest/projectdossier/${id}/project/${projectId}`,
    method: 'DELETE',
  })
  return data
}
